<div class="wrapper">
  <div class="lds-ring">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
  <div>{{ text }}</div>
</div>
